// extracted by mini-css-extract-plugin
module.exports = {"container":"View_container__1dW8E"};